import { render, staticRenderFns } from "./SolicitudRetiro.vue?vue&type=template&id=474f54fc&scoped=true"
import script from "./SolicitudRetiro.vue?vue&type=script&lang=js"
export * from "./SolicitudRetiro.vue?vue&type=script&lang=js"
import style0 from "./SolicitudRetiro.vue?vue&type=style&index=0&id=474f54fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f54fc",
  null
  
)

export default component.exports